let Keyboard = require("../lib/Keyboard");

class Dialog extends React.Component {
  constructor(props) {
    super(props);

    this.onKeyDown = this.onKeyDown.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);

    this.state = {
      index: -1,
      mounted: false
    };
  }

  componentDidMount() {
    this.state.mounted = true;
    this._backing = document.getElementById("mc-content");

    document.body.addEventListener("keydown", this.onKeyDown);
    document.body.addEventListener("keyup", this.onKeyUp);

    setTimeout(this._fadeIn.bind(this), 0);
  }

  componentWillUnmount() {
    this.state.mounted = false;

    document.body.removeEventListener("keydown", this.onKeyDown);
    document.body.removeEventListener("keyup", this.onKeyUp);
  }

  componentDidUpdate() {
    let items = this._getTabItems();
    let index = this.state.index;

    if (items.length && index > -1) {
      items[index].focus();
    }
  }

  _fadeIn() {
    ReactDOM.findDOMNode(this).style.opacity = "1.0";
  }

  show() {
    this._activeElement = document.activeElement;

    this._focus();

    if (this._backing) {
      this._backing.classList.add("mc-screen");
    }

    document.body.style.overflow = "hidden";
  }

  close(evt) {
    this.hide(false);
  }

  hide(confirmed, input) {
    if (this.state.mounted) {
      this._blur();

      if (this._backing) {
        this._backing.classList.remove("mc-screen");
      }

      document.body.style.overflow = "scroll";

      if (this.props.onHide) {
        this.props.onHide(!!confirmed, input);
      }

      // unmount self
      ReactDOM.unmountComponentAtNode(ReactDOM.findDOMNode(this).parentNode);
    }
  }

  onKeyDown(evt) {
    let items;
    let index = this.state.index;

    if (Keyboard.isTab(evt)) {
      evt.preventDefault();
      items = this._getTabItems();
      index += Keyboard.isNextTab(evt) ? 1 : -1;
      index = (items.length + Math.max(-1, index)) % items.length;

      this.setState({ index });
    }
  }

  onKeyUp(evt) {
    if (Keyboard.isEscape(evt) && !/INPUT|SELECT|TEXTAREA/.test(evt.target.nodeName)) {
      this.hide(false);
    }
  }

  _getTabItems() {
    let node = ReactDOM.findDOMNode(this);
    let items = node.querySelectorAll(this.props.selector);
    let filters = node.querySelectorAll(this.props._filters);

    return [].filter.call(items, function (item) {
      let include = !item.disabled;

      for (let i = 0; i < filters.length; i++) {
        if (filters[i].contains(item)) {
          include = false;
          break;
        }
      }

      return include;
    });
  }

  _focus() {
    this.refs.dialog.focus();
  }

  _blur() {
    try {
      if (this._activeElement) {
        this._activeElement.focus();
      }
    }
    catch (e) {
    }
  }
}

module.exports = Dialog;